module.exports = __webpack_public_path__ + "img/21_38.995dc441.png";